// src/api/analyticsApi.ts

import { http } from './http';

export const fetchKPIs = async () => {
  const response = await http.get('/analytics/kpis');
  return response.data;
};

export const fetchSalesTrend = async () => {
  const response = await http.get('/analytics/sales-trend');
  return response.data;
};

export const fetchInventoryDistribution = async () => {
  const response = await http.get('/analytics/inventory-distribution');
  return response.data;
};

export const fetchSalesByLocation = async () => {
  const response = await http.get('/analytics/sales-by-location');
  return response.data;
};

export const fetchCategories = async () => {
  const response = await http.get('/categories');
  return response.data.categories;
};

export const fetchLocations = async () => {
  const response = await http.get('/locations');
  return response.data.locations;
};

export const fetchTopProducts = async (limit = 10) => {
  const response = await http.get('/analytics/top-products', {
    params: { limit }
  });
  return response.data;
};